module.exports = __webpack_public_path__ + "media/components/country-flag/static/tf-541f86503ed373794895495817926cdf.svg";